<template>
  <div  :class="classsolve" id="solve">
    <h3 >解决方案</h3>
    <img src="../../static/assets/jiejuefangan@1x.png">
  </div>
</template>

<script>
    export default {
        name: "solve",
        props:['classsolve'],
        data(){
          return{
          }
        }
    }
</script>

<style lang='less'>
@media only screen and (max-width: 1920px){
  .solve{
    padding-top: 80px;
  }
  #solve{
    h3{
      line-height: 100px;
      color: #333333;
      font-size: 36px;
      font-weight:500;
    }
    img{
      width: 75%;
      height: 75%;
      margin-bottom: 60px;
    }
  }
}
@media only screen and (max-width: 1370px){
  .solve{
    padding-top: 60px;
  }
  #solve h3{
    font-size: 30px;
  }
}
@media only screen and (max-width: 992px){
  #solve h3{
    font-size: 25px;
    line-height: 80px;
  }
  #solve img{
    width: 80%;
    height: 80%;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 768px){
  #solve h3{
    font-size: 15px;
    line-height: 25px;
    margin-bottom: 20px;
  }
  #solve img{
    width: 90%;
    height: 90%;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 600px){
}
</style>



// WEBPACK FOOTER //
// src/components/solve.vue